import { DeckValue } from '@philips-internal/oswald-ui-components';

export class DeckContext {

  private static _paramActivate?: DeckValue[];

  public static getParamActivate(): DeckValue[] | undefined {
    return this._paramActivate;
  }

  public static setParamActivate(param: DeckValue[]): void {
    this._paramActivate = param;
  }

  public static clearParamActivate(): void {
    this._paramActivate = [] as DeckValue[];
  }
}
